import {
  SET_TRASH_LOADING,
  SET_TRASH_PAGINATION_INFO,
  SET_TRASH_DATA,
  RESET_TRASH_STATE
} from './trashActions';

const initialState = {
  trashData: [],
  loading: false,
  paginationInfo: {
    currentPage: 1,
    perPage: 6,
    sortKey: 'created',
    sortDirection: 'desc',
    totalCount: 0
  }
};

const trashReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_TRASH_LOADING:
      return {
        ...state,
        loading: action.payload
      };
    case SET_TRASH_PAGINATION_INFO:
      return {
        ...state,
        paginationInfo: action.payload.paginationInfo
      };
    case SET_TRASH_DATA:
      return {
        ...state,
        trashData: action.payload.trashData
      };
    case RESET_TRASH_STATE:
      return initialState;
    default:
      return { ...state };
  }
};

export default trashReducer;
